import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBrandsProps, IconRender } from '../types.ts';

const Facebook = React.forwardRef<SVGSVGElement | null, IconBrandsProps>(function Facebook({ colored, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M20.5 2C21.3284 2 22 2.67157 22 3.5V20.5C22 21.2767 21.4097 21.9154 20.6533 21.9922L20.5 22H3.5L3.34668 21.9922C2.64069 21.9205 2.07949 21.3593 2.00781 20.6533L2 20.5V3.5C2 2.67157 2.67157 2 3.5 2H20.5ZM3.5 20.5H12.8545V14.1426H10.2158V11.0674H12.8545V8.80371C12.8545 6.1788 14.4573 4.75 16.7988 4.75C17.9201 4.75001 18.8841 4.83379 19.165 4.87109V7.61426H17.5498C16.2761 7.61436 16.0293 8.22007 16.0293 9.1084V11.0674H19.0752L18.6787 14.1426H16.0293V20.5H20.5V3.5H3.5V20.5Z'
          fill={colored ? 'transparent' : color}
        />
        {/* colored */}
        <rect x='2' y='2' width='20' height='20' rx='1.5' fill={colored ? '#4267B2' : 'transparent'} />
        <path
          d='M16.0295 22.001V14.143H18.6786L19.0755 11.0672H16.0295V9.10825C16.0295 8.21985 16.2762 7.61442 17.5501 7.61442H19.1648V4.87085C18.8838 4.83354 17.92 4.75 16.7986 4.75C14.4571 4.75 12.8545 6.17874 12.8545 8.80365V11.0672H10.2153V14.143H12.8545V22.001H16.0295Z'
          fill={colored ? 'white' : 'transparent'}
        />
      </>
    ),
    [colored],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'facebook-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Facebook;
